import { createAction, props } from '@ngrx/store';
import { withNameSpace } from './message-conversation.actions';
import { MediaState } from '../models/message-media-state.enum';

export const sendMediaMessage = createAction(
  withNameSpace('Send media message'),
  props<{ conversationId: string, mediaIds: string[] }>()
);

export const sendMediaMessageSuccess = createAction(
  withNameSpace('Send media message success'),
  props<{ conversationId: string }>()
);

export const sendMediaMessageFailure = createAction(
  withNameSpace('Send media message failure'),
  props<{ conversationId: string }>()
);

export const uploadMedia = createAction(
  withNameSpace('Upload media'),
  props<{ conversationId: string, file: FormData }>()
);

export const uploadMediaSuccess = createAction(
  withNameSpace('Upload media success'),
  props<{ conversationId: string, mediaId: string, status: MediaState }>()
);

export const uploadMediaFailure = createAction(
  withNameSpace('Upload media failure'),
  props<{ conversationId: string, status: MediaState }>()
);
